function themeElement() {
  if (document.body?.getAttribute("data-bs-theme")) return document.body
  return document.documentElement
}

function cssVar(name, fallback) {
  const value = getComputedStyle(themeElement()).getPropertyValue(name).trim()
  return value || fallback
}

export function readStripeAppearance() {
  const el = themeElement()
  const isDark = el.getAttribute("data-bs-theme") === "dark"

  const bodyBg = cssVar("--bs-body-bg", isDark ? "#212529" : "#ffffff")
  const bodyColor = cssVar("--bs-body-color", isDark ? "#dee2e6" : "#212529")
  const borderColor = cssVar("--bs-border-color", isDark ? "#495057" : "#dee2e6")
  const primary = cssVar("--bs-primary", "#0d6efd")
  const danger = cssVar("--bs-danger", "#dc3545")
  const secondaryColor = cssVar("--bs-secondary-color", isDark ? "#adb5bd" : "#6c757d")
  const inputBg = cssVar("--bs-tertiary-bg", isDark ? "#2b3035" : "#f8f9fa")

  return {
    theme: isDark ? "night" : "stripe",
    variables: {
      colorPrimary: primary,
      colorBackground: bodyBg,
      colorText: bodyColor,
      colorDanger: danger,
      colorTextPlaceholder: secondaryColor,
      fontFamily: "Nunito, system-ui, sans-serif",
      spacingUnit: "2px",
      borderRadius: "4px"
    },
    rules: {
      ".Input": {
        backgroundColor: inputBg,
        borderColor: borderColor,
        color: bodyColor
      },
      ".Tab": {
        borderColor: borderColor,
        backgroundColor: inputBg,
        color: bodyColor
      },
      ".Tab--selected": {
        borderColor: primary,
        color: bodyColor
      },
      ".TabIcon--selected": {
        fill: primary
      },
      ".Label": {
        color: bodyColor
      },
      ".Block": {
        backgroundColor: bodyBg,
        borderColor: borderColor
      }
    }
  }
}

export function observeStripeTheme(callback) {
  const handler = () => callback()
  document.addEventListener("depozen:theme-changed", handler)
  return () => document.removeEventListener("depozen:theme-changed", handler)
}
